// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3bq1i","file":"styles_file__fDbmI"};